<div class="registration-container">
Toggle Buttons -->
    <div class="toggle-buttons">
        <button mat-raised-button [color]="selectedForm === 'vendor' ? 'primary' : ''"
            (click)="selectedForm = 'vendor'">
            Vendor Registration
        </button>
        <button mat-raised-button [color]="selectedForm === 'employee' ? 'primary' : ''"
            (click)="selectedForm = 'employee'">
            Employee Registration
        </button>
    </div>

    <!-- 
    <!-- Vendor Registration Form -->
    <div *ngIf="selectedForm === 'vendor'" class="form-view">
        <form [formGroup]="vendorForm" (ngSubmit)="submitVendorForm()" class="form-container">

            <mat-form-field appearance="outline">
                <mat-label>Company Name</mat-label>
                <input matInput formControlName="companyName" required>
                <!-- <mat-error *ngIf="registrationForm.get('companyName')!.hasError('required')">
            Company Name required
        </mat-error> -->
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Address Line 1</mat-label>
                <input matInput formControlName="address1" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Additional Address Line 2</mat-label>
                <input matInput formControlName="address2">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Building Number</mat-label>
                <input matInput formControlName="buildingNumber" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Additional Number</mat-label>
                <input matInput formControlName="additionalNumber">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Country</mat-label>
                <mat-select formControlName="countryId" required>
                    <mat-option *ngFor="let c of countries" [value]="c.id">{{ c.name }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>State/Province</mat-label>
                <mat-select formControlName="stateId" required>
                    <mat-option *ngFor="let s of states" [value]="s.id">{{ s.name }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>District/Neighborhood</mat-label>
                <mat-select formControlName="districtId" required>
                    <mat-option *ngFor="let d of districts" [value]="d.id">{{ d.name }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input matInput formControlName="city" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>VAT Number</mat-label>
                <input matInput formControlName="vatNumber" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Group VAT Number</mat-label>
                <input matInput formControlName="groupVatNumber">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Other ID</mat-label>
                <input matInput formControlName="otherId">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Commercial Reg. No</mat-label>
                <input matInput formControlName="commercialRegNo" required>
            </mat-form-field>

            <!-- File Uploads -->
            <div class="file-upload">
                <label>Company VAT Certificate*</label>
                <input type="file" (change)="onFileChange($event, 'companyVatCert')" required>
            </div>

            <div class="file-upload">
                <label>MOMRA License</label>
                <input type="file" (change)="onFileChange($event, 'momraLicenseFile')">
            </div>

            <div class="file-upload">
                <label>MSLD License</label>
                <input type="file" (change)="onFileChange($event, 'msldLicenseFile')">
            </div>

            <div class="file-upload">
                <label>SAGIA License</label>
                <input type="file" (change)="onFileChange($event, 'sagiaLicenseFile')">
            </div>

            <mat-form-field appearance="outline">
                <mat-label>Nature of your business</mat-label>
                <mat-select formControlName="natureOfBusiness" required>
                    <mat-option *ngFor="let type of businessTypes" [value]="type">{{ type }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-checkbox formControlName="suppliedEarlier">Have you supplied the material to GS earlier?</mat-checkbox>

            <mat-form-field appearance="outline" *ngIf="vendorForm.get('suppliedEarlier')?.value">
                <mat-label>Month & Year</mat-label>
                <input matInput formControlName="suppliedMonthYear">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Contact Person</mat-label>
                <input matInput formControlName="contactPerson" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <mat-select formControlName="titleId" required>
                    <mat-option *ngFor="let t of titles" [value]="t.id">{{ t.name }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Designation</mat-label>
                <input matInput formControlName="designation" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Phone</mat-label>
                <input matInput formControlName="phone" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input matInput formControlName="mobile" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" required>
            </mat-form-field>

            <button mat-raised-button color="primary" type="submit">Submit Vendor</button>
        </form>
    </div>

    <!-- Employee Registration Form -->
    <div *ngIf="selectedForm === 'employee'" class="form-view">
        <form [formGroup]="employeeForm" (ngSubmit)="submitEmployeeForm()" class="form-container">

            <!-- <mat-form-field appearance="outline">
                <mat-label>Employee Name</mat-label>
                <input matInput formControlName="employeeName" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Employee ID</mat-label>
                <input matInput formControlName="employeeId" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" required>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Department</mat-label>
                <input matInput formControlName="department" required>
            </mat-form-field> -->

            <button mat-raised-button color="accent" type="submit">Submit Employee</button>
        </form>
    </div>
</div>